import React from 'react';
import ReactToPrint from "react-to-print";

export default class Page8 extends React.Component {

    generateGraphNumbers = (name, position) => {
        const {pageData} = this.props;

        let html = [];
        const pageLength = pageData?.[name] ? Object.values(pageData?.[name]).filter(value => value).length : 0;

        if (position === 'top') {
            for (let i = 5; i >= 1; i--) {
                if (pageLength === i) {
                    html.push(<div className={name + '_' + i}>{i}</div>);
                } else {
                    html.push(<div className={name + '_' + i} dangerouslySetInnerHTML={{__html: '&nbsp;'}}/>);
                }
            }
        } else {
            for (let i = 1; i <= 5; i++) {
                if (pageLength === i) {
                    html.push(<div className={name + '_' + i}>{i}</div>);
                } else {
                    html.push(<div className={name + '_' + i} dangerouslySetInnerHTML={{__html: '&nbsp;'}}/>);
                }
            }
        }

        return html;
    };

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="ilead-rgt people">
                                <div className="innerpadding">
                                    <div className="ilead-contentarea">
                                        <div className="circle_title-first">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                            <span className="heading">THE MOTIVATION WEB</span>
                                        </div>

                                        <table className="ilead_v_sport people_active" border="0"
                                               cellPadding="0" cellSpacing="0" width="100%">
                                            <tbody>
                                            <tr>
                                                <th className="green_curve green_curve1" align="left"
                                                    valign="top" width="100%">Name
                                                </th>
                                            </tr>
                                            <tr>
                                                <td className="lightgreen" align="left" valign="top"
                                                    width="100%"><textarea rows="5"
                                                                           name="TheMotivationWebTextarea"
                                                                           id="TheMotivationWebTextarea" cols="100"
                                                                           className="namecontent"
                                                                           value={this.props.pageData?.TheMotivationWebTextarea}
                                                                           onChange={this.props.handleChangeTextarea}/>
                                                </td>


                                            </tr>
                                            </tbody>
                                        </table>
                                        <ReactToPrint
                                            trigger={() => <div className={'d-flex justify-content-end'}>
                                                <div onClick={this.downloadPdf} className="button-print">Print</div>
                                            </div>}
                                            content={ () => {
                                                let html = document.body.getElementsByClassName('ilead-tools-pages-content')[0].cloneNode(true);

                                                let div1 = document.createElement('div');
                                                div1.className = 'ilead-tools-pages';
                                                div1.appendChild(html);

                                                let div2 = document.createElement('div');
                                                div2.className = 'ilead-tools-body react-print';
                                                div2.appendChild(div1);

                                                return div2.cloneNode(true);
                                            }}
                                        />

                                        <br/>
                                            <div className="innovativeimg">
                                                <div className="mobile-scroll ipad-view">
                                                    <div className="spiderbg1">
                                                        <div className="spidertop_1">
                                                            {this.generateGraphNumbers('control', 'top')}
                                                        </div>
                                                        <div className="spidertop_2">
                                                            <div className="achievebox">
                                                                {this.generateGraphNumbers('achieve', 'top')}
                                                            </div>
                                                        </div>
                                                        <div className="spidertop_3">
                                                            {this.generateGraphNumbers('please', 'top')}
                                                        </div>
                                                        <div className="middlleleft">
                                                            {this.generateGraphNumbers('care', 'top')}
                                                        </div>
                                                        <div className="middlleright">
                                                            {this.generateGraphNumbers('belong')}
                                                        </div>
                                                        <div className="spidertop_6">
                                                            {this.generateGraphNumbers('structure')}
                                                            <div className="structure_5">&nbsp;</div>
                                                        </div>
                                                        <div className="spidertop_7">
                                                            <div className="achievebox">
                                                                {this.generateGraphNumbers('variety')}
                                                            </div>
                                                        </div>
                                                        <div className="spidertop_8">
                                                            {this.generateGraphNumbers('autonomy')}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                    </div>

                                    <div className="buttonposition">
                                        <div className="left-btn"><div
                                            onClick={this.props.handleChangePage('Page7')}
                                            className="button-next-previous-done">&lt;&lt; Previous </div></div>
                                        <div className="right-btn"><div
                                            onClick={this.props.savePageData('Page9')}
                                            className="button-next-previous-done">Next &gt;&gt;</div></div>
                                        <div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}